/**
 * Feature Flags Configuration
 *
 * Toggle features on/off for different project needs.
 * Set these via environment variables or modify defaults here.
 */

export interface Features {
  /** Enable authentication system */
  auth: boolean;

  /** Enable Supabase backend integration */
  supabase: boolean;

  /** Enable Stripe payment integration */
  stripe: boolean;

  /** Enable dark mode toggle */
  darkMode: boolean;
}

/**
 * Parse boolean from environment variable
 */
const parseEnvBool = (value: string | undefined, defaultValue: boolean): boolean => {
  if (value === undefined) return defaultValue;
  return value.toLowerCase() === 'true';
};

export const features: Features = {
  auth: parseEnvBool(import.meta.env.VITE_ENABLE_AUTH, true),
  supabase: parseEnvBool(import.meta.env.VITE_ENABLE_SUPABASE, true),
  stripe: parseEnvBool(import.meta.env.VITE_ENABLE_STRIPE, false),
  darkMode: true,
};

/**
 * Check if a feature is enabled
 */
export const isFeatureEnabled = (feature: keyof Features): boolean => {
  return features[feature];
};

/**
 * Runtime feature check hook helper
 */
export const requireFeature = (feature: keyof Features): void => {
  if (!features[feature]) {
    throw new Error(
      `Feature "${feature}" is not enabled. Enable it in your .env file or config/features.ts`
    );
  }
};
